<div class="no-scroll patient-ob">

    <div class="wrapper">
        <!-- pop up -->
        <!-- <div *ngIf="showPrintPopup" class="print-history-popup">
            <div class="print-history-popup-body">
              <h2 class="popup-title">select for print:</h2>
              <button
                (click)="togglePrintPopup()"
                class="print-history-popup-close"
                aria-label="close popup"
              ></button>
              <strong class="linked-radios-row pointer" (click)="printPathologyForm()">Print Pathologies Form</strong>
            </div>
          </div> -->
        <!-- ========================== Header (Start) ========================== -->
        <header class="l-header">

            <div class="on-mobile header-logo">
                <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
            </div>
            <div class="l-header-panel">

                <i class="off-mobile header-icon icon-fetus" *ngIf="false"></i>

                <div >
                {{patInbox.length > 0 ? 'Lab Reports that need exam assignment' : ''}}
                <ng-container *ngFor="let inbox of patInbox">
                    <a (click)="labReportID = inbox.AutoIndex" matTooltip="{{inbox.Lab}} report received on {{inbox.ReceptionDate | date:'dd/MM/yyyy HH:mm'}}">
                         <img src="../../assets/icons/file.svg" style="height: 1.5em;margin-right: 1em;"/>
                    </a>
                </ng-container>
                
                </div>

                <nav class="header-menu">

                    <img *ngIf="pat.ID != 'default'"
                      style="cursor: pointer; align-self: center"
                      matTooltip="Attach Document"
                      height="41em"
                      width="41em"
                      (click)="openDocumentsAdd = true"
                      src="../../assets/icons/fileupload.svg"
                    />

                    <!-- <a href="#" class="header-menu-link icon-book" aria-label="library"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-print" aria-label="Print"></a> -->
                    <!-- <a (click)="calendarForm = true;selectedForm=null;cf.selcForm=null" class="header-menu-link icon-calendar" matTooltip="Pregnancy Planner" style="background-color: white;border-radius: 5px;cursor: pointer" aria-label="calendar" *ngIf="!login.isCardio && !login.isUSG && login.premissions.Planner"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-chart" aria-label="chart"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-image" aria-label="image"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-searchdoc" aria-label="image"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-save" aria-label="save"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-date" aria-label="date"></a> -->
                    <!-- <a href="#" class="header-menu-link icon-confirm" aria-label="confirm"></a> -->

                </nav>

                <nav class="on-mobile header-mobilePanel">
                    <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"
                        aria-label="open mobile menu"></button>
                    <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"
                        aria-label="open mobile sidebar"></button>
                </nav>

            </div>

        </header>
        <!-- ========================== Header (End) ========================== -->


        <!-- ========================== Dashboard Main Content (Start) ========================== -->

        <main class="l-deashboard">

            <div class="h100 l-flex l-flex-w t-boxMargin--spacebyPadding">

                <!-- ========================== Patient History Panel (Start) ========================== -->
                <div class="w50 patient-ob-box">
                    <div class="h100 m-box" *ngIf="pat.ID === 'default'" [formGroup]="examService.newTitleItem">
                        <h2>Additional Titles Setting</h2>
                        <div class="h100 l-flex l-column" style="justify-content: space-between;">
                            <div>
                                <div class="headDiv">
                                    <div class="inputLine">
                                            <section>
                                                <span>Define new title:</span>              
                                                <input class="input" #inputTitle type="text" formControlName="Title"
                                                    [value]="examService.newTitleItem.get('Title').value">
                                            </section>
                                            <span class="t-validation-wrap l-fg1" style="text-align: center;">
                                            <span class="s-count" *ngIf="examService.CustomTitles">
                                                <span [ngClass]="(! examService.disableSaveTitle) ? '':'is-invalid'">
                                                    <strong>{{examService.CustomTitles ? examService.CustomTitles.length : 0 }}/8</strong>
                                                </span>
                                                <div class="t-validation-message">
                                                    <span>Maximum Custom Titles, Please Remove One</span>
                                                </div>
                                            </span>
                                            </span>
                                            <button (click)="examService.saveNewTitle(login.ClinicID,false)" style="background-color: #d7a95b;color: white;width: 4em;border-radius: 10px;">save</button>
                                    </div>
                                </div>
                                <div>
                                    <div class="linked-radios-list linked-radios-set" style="margin-top: 0;"
                                        [formGroup]="examService.newTitleItem">
                                        <label class="linked-radios-item" *ngFor="let c of examService.CustomTitles">
                                            <input type="radio" [value]="c.AutoIndex" formControlName="AutoIndex"
                                                (click)="examService.getTitle(c.AutoIndex)" />
                                            <span class="linked-radios-row">
                                                <span class="l-fg1 linked-radios-title" (dblclick)="examService.resetTitleItem()">{{c.Title}}</span>
                                                <span class="linked-radios-duration" style="margin-inline-end: 5em;">
                                                    <p> {{c.Creation | date:"dd/MM/yyyy"}} at {{c.Creation | date:"HH:mm"}}
                                                    </p>
                                                </span>
                                                <span class="linked-radios-duration"><img src="../../assets/icons/del.svg"
                                                        matTooltip="Delete"
                                                        (click)="examService.deleteTitle(c.AutoIndex)"></span>
                                                <!-- <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Fetal Echo']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)='deleteDefault("Specialized")'> 12-40 Weeks</span> -->
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- Signature Upload Section -->
                            <div *ngIf="login.userType === 'doctor' && login.premissions?.Consent" style="margin-top: 1.5em; padding: 1em; border: 1px solid #e0e0e0; border-radius: 8px;">
                              <h3 style="margin: 0 0 0.5em 0;">Doctor Signature</h3>
                              <div *ngIf="signatureLoading" style="display:flex; align-items:center; gap:0.5em;">
                                <span>Loading...</span>
                              </div>
                              <div *ngIf="!signatureLoading && currentSignatureUrl" style="margin-bottom: 0.5em;">
                                <img [src]="currentSignatureUrl" style="max-height: 80px; border: 1px solid #ccc; border-radius: 4px;" alt="Current Signature">
                              </div>
                              <div class="l-flex l-flex-c" style="gap: 0.5em;">
                                <input type="file" #signatureFile accept="image/*" style="display:none" (change)="onSignatureFileSelected($event)">
                                <button class="accept" (click)="signatureFile.click()" [disabled]="signatureLoading" style="min-width: auto; height: auto; padding: 0.4em 1em;">
                                  {{ currentSignatureUrl ? 'Replace Signature' : 'Upload Signature' }}
                                </button>
                                <button class="cancel" *ngIf="currentSignatureUrl" (click)="deleteSignature()" [disabled]="signatureLoading" style="min-width: auto; height: auto; padding: 0.4em 1em;">
                                  Delete Signature
                                </button>
                                <span *ngIf="signatureUploadStatus" style="color: green; font-size: 0.9em;">{{ signatureUploadStatus }}</span>
                              </div>
                            </div>

                            <!-- Secretary: Manage Doctor Signatures -->
                            <div *ngIf="login.userType === 'secretary' && login.premissions?.Consent && clinicPractitioners?.length" style="margin-top: 1.5em; padding: 1em; border: 1px solid #e0e0e0; border-radius: 8px;">
                              <h3 style="margin: 0 0 0.75em 0;">Doctor Signatures</h3>
                              <div *ngFor="let p of clinicPractitioners" style="display:flex; align-items:center; gap:1em; padding: 0.5em 0; border-bottom: 1px solid #f0f0f0;">
                                <span style="min-width: 10em; font-weight: 500;">{{ p.Title }} {{ p.Name }}</span>
                                <ng-container *ngIf="practitionerSignatures[p.UID] as sig">
                                  <span *ngIf="sig.loading" style="font-size: 0.85em; color: #888;">Loading...</span>
                                  <img *ngIf="!sig.loading && sig.url" [src]="sig.url"
                                    style="max-height: 50px; max-width: 120px; border: 1px solid #ccc; border-radius: 4px; cursor: zoom-in; transition: transform 0.2s; position: relative; z-index: 1;"
                                    (mouseenter)="$event.target.style.transform='scale(3)'; $event.target.style.zIndex='100'"
                                    (mouseleave)="$event.target.style.transform='scale(1)'; $event.target.style.zIndex='1'"
                                    alt="Signature">
                                  <span *ngIf="!sig.loading && !sig.url" style="font-size: 0.85em; color: #aaa;">No signature</span>
                                  <input type="file" #sigFileInput accept="image/*" style="display:none" (change)="onPractitionerSignatureSelected(p.UID, $event)">
                                  <button class="accept" (click)="sigFileInput.click()" [disabled]="sig.loading" style="min-width: auto; height: auto; padding: 0.3em 0.8em; font-size: 0.85em;">
                                    {{ sig.url ? 'Replace' : 'Upload' }}
                                  </button>
                                  <button class="cancel" *ngIf="sig.url" (click)="deletePractitionerSignature(p.UID)" [disabled]="sig.loading" style="min-width: auto; height: auto; padding: 0.3em 0.8em; font-size: 0.85em;">
                                    Delete
                                  </button>
                                  <span *ngIf="sig.status" style="color: green; font-size: 0.8em;">{{ sig.status }}</span>
                                </ng-container>
                              </div>
                            </div>

                            <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                                    Exit Titles Setting
                                </a>
                                <!-- <button class="patient-ob-btn -start_exam" [ngClass]="examname && etype ? '': 'opaque'"
                                    (click)="startExam()" *ngIf="canOpen()">
                                    {{pat.ID != 'default' ? (etype!= 'Forms'?'Start Exam': 'New Letter') :
                                    'Construct/Edit Defaults'}}
                                </button> -->
                            </div>
                        </div>
                    </div>
                    <div class="h100 m-box" *ngIf="pat.ID != 'default'">
                        <h2>Patient History</h2>
                        <ng-container *ngIf="usGeneralExams && usGeneralExams.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Exams</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let exam of usGeneralExams">
                                        <span class="l-fg1 examlink" (click)="goExam(null,exam,exam.ExamType, exam.CreationTime)" (contextmenu)="askDelete(exam)">
                                            <strong *ngIf="exam.Draft"> * </strong>
                                            {{exam.Changed ? exam.ChangedExamTitle : (exam.SubExamType ? getSubExamLabel(exam.SubExamType) : exam.ExamType)}}
                                            <ng-container *ngIf="exam.Locked"><img src="../../assets/icons/login/password.svg" style='height: 1em'>{{exam.LockedBy}}</ng-container>
                                        </span>
                                        <img src="../../assets/icons/print-history.svg" style='height: 1.5em' matTooltip="print Form of Pathology Submission" (click)="printPathologyForm(exam.AutoIndex)" *ngIf="exam.ExamType !== 'Abdomen US' && (exam.Reasone || examService.GASTRO.includes(exam.ExamType))" />
                                        <img src="../../assets/icons/blood-test-referral.svg" style='height: 1.5em; cursor:pointer; background:#277382; border:1px solid #277382; border-radius:4px; padding:3px; box-sizing:content-box; vertical-align:middle' matTooltip="הפניה לבדיקות מעבדה (לחיצה ימנית למחיקה)" (click)="openReferralPrintout(exam.ReferralId)" (contextmenu)="askDeleteReferral(exam, $event)" *ngIf="exam.ReferralId" />
                                        <span style='margin-right:2em'>by {{exam.Opener}}</span>
                                        <span
                                            *ngIf="exam.SignedDate"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Signed {{exam.SignedDate | date:"dd/MM/yyyy"}}
                                        </span>
                                        <span
                                            *ngIf="!exam.SignedBy"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Not Reviewed
                                        </span>
                                        <span class="linked-radios-date">{{exam.CreationTime | date:"dd/MM/yyyy"}} at {{exam.CreationTime | date:"HH:mm"}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="formsExams && formsExams.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Forms</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let exam of formsExams">
                                        <span class="l-fg1 examlink" (click)="goExam(null,exam,exam.ExamType, exam.CreationTime)" (contextmenu)="askDelete(exam)">
                                            <strong *ngIf="exam.Draft"> * </strong>
                                            {{exam.Changed ? exam.ChangedExamTitle : exam.ExamType}}
                                            <ng-container *ngIf="exam.Locked"><img src="../../assets/icons/login/password.svg" style='height: 1em'>{{exam.LockedBy}}</ng-container>
                                        </span>
                                        <img src="../../assets/icons/blood-test-referral.svg" style='height: 1.5em; cursor:pointer; background:#277382; border:1px solid #277382; border-radius:4px; padding:3px; box-sizing:content-box; vertical-align:middle' matTooltip="הפניה לבדיקות מעבדה (לחיצה ימנית למחיקה)" (click)="openReferralPrintout(exam.ReferralId)" (contextmenu)="askDeleteReferral(exam, $event)" *ngIf="exam.ReferralId" />
                                        <span style='margin-right:2em'>by {{exam.Opener}}</span>
                                        <span
                                            *ngIf="exam.SignedDate"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Signed {{exam.SignedDate | date:"dd/MM/yyyy"}}
                                        </span>
                                        <span
                                            *ngIf="!exam.SignedBy"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Not Reviewed
                                        </span>
                                        <span class="linked-radios-date">{{exam.CreationTime | date:"dd/MM/yyyy"}} at {{exam.CreationTime | date:"HH:mm"}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="clinicsExams && clinicsExams.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Clinics</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let exam of clinicsExams">
                                        <span class="l-fg1 examlink" (click)="goExam(null,exam,exam.ExamType, exam.CreationTime)" (contextmenu)="askDelete(exam)">
                                            <strong *ngIf="exam.Draft"> * </strong>
                                            {{exam.Changed ? exam.ChangedExamTitle : exam.ExamType}}
                                            <ng-container *ngIf="exam.Locked"><img src="../../assets/icons/login/password.svg" style='height: 1em'>{{exam.LockedBy}}</ng-container>
                                        </span>
                                        <span style='margin-right:2em'>by {{exam.Opener}}</span>
                                        <span
                                            *ngIf="exam.SignedDate"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Signed {{exam.SignedDate | date:"dd/MM/yyyy"}}
                                        </span>
                                        <span
                                            *ngIf="!exam.SignedBy"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Not Reviewed
                                        </span>
                                        <span class="linked-radios-date">{{exam.CreationTime | date:"dd/MM/yyyy"}} at {{exam.CreationTime | date:"HH:mm"}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="login.premissions?.Consent && usgConsents && usgConsents.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Consent Forms</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let concent of usgConsents">
                                        <span class="l-fg1 examlink" (click)="startForm(concent)">
                                            Consent form for {{ concent.ConsentType }}
                                        </span>
                                        <div
                                            [ngClass]="checkApprovedUsgConsent(concent) ? 'signed-consent' : 'not-signed-consent'"
                                            [matTooltip]="checkApprovedUsgConsent(concent) ? 'Consent Signed' : 'Consent Not Signed'"
                                        ></div>
                                        <span style="margin-right: 2em">{{ concent.Opener }}<span *ngIf="concent.refferalDoc"> | ד"ר {{ concent.refferalDoc }}</span></span>
                                        <span class="linked-radios-date">{{ concent.CreationTime | date:'dd/MM/yyyy' }} at {{ concent.CreationTime | date:'HH:mm' }}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <!-- ========================== Questionnaires (Start) ========================== -->
                        <ng-container *ngIf="login.premissions?.Questionnaires && patientQuestionnaires && patientQuestionnaires.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">{{ 'GUI.General.Buttons.Questionnaires' | translate }}</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let q of patientQuestionnaires">
                                        <span
                                            class="l-fg1 examlink"
                                            [style.cursor]="q.answeredDate ? 'pointer' : 'default'"
                                            (click)="q.answeredDate && openQuestionnairePdf(q)"
                                        >
                                            {{ q.name }}
                                        </span>
                                        <div
                                            [ngClass]="q.answeredDate ? 'signed-consent' : 'not-signed-consent'"
                                        ></div>
                                        <span class="linked-radios-date">{{ (q.answeredDate || q.sentDate) | date:'dd/MM/yyyy' }}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <!-- ========================== Questionnaires (End) ========================== -->
                        <ng-container *ngIf="login.premissions?.Prescriptions && prescriptions && prescriptions.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Prescriptions</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let rx of prescriptions" (click)="openPrescription(rx.AutoIndex, rx.CreatedAt)" (contextmenu)="askDeletePrescription(rx, $event)" style="cursor:pointer;">
                                        <span class="l-fg1 examlink">
                                            <strong *ngIf="rx.Status =='draft'"> * </strong>
                                            Prescription
                                        </span>
                                        <span style='margin-right:2em'>by {{rx.Opener}}</span>
                                        <span
                                            *ngIf="rx.SignedAt"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Signed {{rx.SignedAt | date:"dd/MM/yyyy"}}
                                        </span>
                                        <span
                                            *ngIf="!rx.SignedAt"
                                            style="width: 20%; margin-right: 2em; white-space: nowrap"
                                        >
                                            Not Reviewed
                                        </span>
                                        <span class="linked-radios-date">{{rx.CreatedAt | date:"dd/MM/yyyy"}} at {{rx.CreatedAt | date:"HH:mm"}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <!-- patient documents -->
                        <ng-container *ngIf="AttachedDocuments && AttachedDocuments.length > 0">
                            <div class="linked-radios-list linked-radios-set">
                                <strong class="linked-radios-row" style="margin-bottom: 1%;">Attached Documents</strong>
                                <ul>
                                    <li class="l-flex l-flex-c" *ngFor="let document of AttachedDocuments">
                                        <span class="l-fg1 examlink" (click)="openDocument(document.AutoIndex)" (contextmenu)="askDelete(document, true)" style="cursor:pointer;">
                                            {{document.title}}
                                        </span>
                                        <span style="margin-right: 2em">{{document.comments}}</span>
                                        <span class="linked-radios-date">{{document.CreationTime | date:"dd/MM/yyyy"}} at {{document.CreationTime | date:"HH:mm"}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                    </div>


                </div>
                <!-- ========================== Patient History Panel (End) ========================== -->

                <!-- ========================== Create New Exam Panel (Start) ========================== -->
                <div class="w50 patient-ob-box">

                    <div class="h100 m-box">

                        <h2>{{login.userType=='nurse'?"Forms Management":pat.ID != 'default' ? 'Create New': 'Exams Defaults Setting'}}</h2>

                        <div class="h100 l-flex l-column" style="height: fit-content;">

                            <div class="l-fg1">

                                <div class="">

                                    <!-- ========================== New Exam Type Selector (Start) ========================== -->
                                    <div class="l-flex-c l-flex-w l-justify h50 new_exam-head" *ngIf="login.userType!=='nurse'">
                                        <!-- <label class="t-label-top" *ngIf="login.isUSG && login.category.name !== 'forms'">
                                            <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Gastro"/>
                                            <i class="customInput-display"></i>
                                            <span>
                                                Exams
                                            </span>
                                        </label> -->
                                        <ng-container *ngIf="login.isUSG">
                                            <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                                                <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Ultrasound" (ngModelChange)="onEtypeChange()"/>
                                                <i class="customInput-display"></i>
                                                <span>
                                                    Ultrasound-Imaging
                                                </span>
                                            </label>
                                            <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                                                <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Endoscopy" (ngModelChange)="onEtypeEndoscopyChange()"/>
                                                <i class="customInput-display"></i>
                                                <span>
                                                    Endoscopy-Procedures
                                                </span>
                                            </label>
                                        </ng-container>
                                        <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                                            <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Forms" (ngModelChange)="onEtypeChange()"/>
                                            <i class="customInput-display"></i>
                                            <span>
                                                Letters and Forms
                                            </span>
                                        </label>
                                        <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                                            <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="clinics" (ngModelChange)="onEtypeChange()"/>
                                            <i class="customInput-display"></i>
                                            <span>
                                                Clinics
                                            </span>
                                        </label>


                                        

                                    </div>
                                    <!-- ========================== New Exam Type Selector (End) ========================== -->

                                    <div class="linked-radios-list linked-radios-set">
                                    

                                        <ng-container *ngIf="etype == 'clinics'">
                                            <label class="linked-radios-item" *ngFor="let t of myClinicTemplates">
                                                <input type="radio" name="TEMP_name1" [value]="t.ClinicTemplateID"
                                                    [(ngModel)]="selectedClinicTemplateId" (ngModelChange)="selectClinicTemplate(t)" />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">{{ t.Title }}</span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <div *ngIf="!myClinicTemplates.length" class="linked-radios-item">No clinic templates assigned.</div>
                                        </ng-container>

                                        <ng-container *ngIf="etype == 'Forms'">
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Consultation Letter"
                                                    [(ngModel)]="examname" />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Consultation Letter</span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label *ngIf="login.premissions && login.premissions.ConsultationFollowUpMedia" class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="consultation and follow up with media"
                                                    [(ngModel)]="examname" />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Consultation and Follow Up with Media</span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>            
                                            <label class="linked-radios-item" *ngIf="login.premissions?.Prescriptions">
                                                <input type="radio" name="TEMP_name1" value="Prescription"
                                                    [(ngModel)]="examname" />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Prescription</span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item" *ngIf="login.premissions?.Consent">
                                                <input type="radio" name="TEMP_name1" value="Inform Consent" [(ngModel)]="examname"  />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">
                                                        {{ 'Informed Consent' }}
                                                        <span *ngIf="login.premissions?.concentLimit" style="align-self: center; margin-inline-start: 2.31em"
                                                            [ngClass]="
                                                                            login.concentCount >= login.premissions?.concentLimit ? 'error' : ''
                                                                          ">
                                                            {{ login.concentCount }}/{{ login.premissions?.concentLimit }}
                                                        </span>
                                                    </span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item" *ngIf="login.premissions?.Questionnaires">
                                                <input type="radio" name="TEMP_name1" value="Send Questionnaire" [(ngModel)]="examname" />
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">New Questionnaire</span>
                                                    <span class="linked-radios-duration"></span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>


                                        </ng-container>






                                        <ng-container *ngIf="etype == 'Invasive'">
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Amniocentesis" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Amniocentesis</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="CVS" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">CVS</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                        </ng-container>
                                        <ng-container *ngIf="etype === 'Gastro'">
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Gastroscopy" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Gastroscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Colonoscopy" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Colonoscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Sigmoidoscopy" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Sigmoidoscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label *ngIf="login.premissions && login.premissions.HemorrhoidsTreatment" class="linked-radios-item" >
                                                <input type="radio" name="TEMP_name1" value="Hemorrhoids Treatment" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Hemorrhoids Treatment</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                        </ng-container>

                                        <ng-container *ngIf="etype === 'Endoscopy'">
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" [(ngModel)]="endoscopySubType" value="Gastro" (ngModelChange)="onEndoscopySubTypeChange()"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Gastroscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" [(ngModel)]="endoscopySubType" value="Colonoscopy" (ngModelChange)="onEndoscopySubTypeChange()"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Colonoscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" [(ngModel)]="endoscopySubType" value="Both" (ngModelChange)="onEndoscopySubTypeChange()"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Gastro + Colonoscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" [(ngModel)]="endoscopySubType" value="HRA" (ngModelChange)="onEndoscopySubTypeChange()"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">HRA</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" [(ngModel)]="endoscopySubType" value="Other" (ngModelChange)="onEndoscopySubTypeChange()"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Other Endoscopy</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                        </ng-container>

                                        <ng-container *ngIf="etype === 'Ultrasound'">
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Abdomen US" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Abdomen US</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <!-- <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="MSK Musculoskeletal" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">MSK Musculoskeletal</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label> -->
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="MSK & Soft Tissues" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">MSK &amp; Soft Tissues</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Neck scan" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Neck scan</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Ultrasound Scan Summary" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row">
                                                    <span class="l-fg1 linked-radios-title">Ultrasound Scan Summary</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                        </ng-container>

                                        <ng-container *ngIf="etype == 'GastroForms'">
                                            <label class="linked-radios-item" >
                                                <input type="radio" name="TEMP_name1" value="Admission Form" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row" [ngStyle]="login.userType === 'nurse' ? getStyle('Admission Form'): {}" >
                                                    <span class="l-fg1 linked-radios-title">Admission Form</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Time Out Form" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row" [ngStyle]="login.userType === 'nurse' ? getStyle('Time Out Form'): {}">
                                                    <span class="l-fg1 linked-radios-title">Time Out Form</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Course Of Exam" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row" [ngStyle]="login.userType === 'nurse' ? getStyle('Course Of Exam'): {}">
                                                    <span class="l-fg1 linked-radios-title">Course Of Exam</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Recovery Form" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row" [ngStyle]="login.userType === 'nurse' ? getStyle('Recovery Form'): {}">
                                                    <span class="l-fg1 linked-radios-title">Recovery Form</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                            <label class="linked-radios-item">
                                                <input type="radio" name="TEMP_name1" value="Release Form" [(ngModel)]="examname"/>
                                                <span class="linked-radios-row" [ngStyle]="login.userType === 'nurse' ? getStyle('Release Form'): {}">
                                                    <span class="l-fg1 linked-radios-title">Release Form</span>
                                                    <span class="linked-radios-counter"><i>1</i></span>
                                                </span>
                                            </label>
                                        </ng-container>
                                   
                                        
                                    </div>

                                </div>

                            </div>

                            <!-- ========================== Consent Type And Practitioner Selector (Start) ========================== -->
 <ng-container
                *ngIf="
                  etype === 'Forms' &&
                  login.premissions?.Consent &&
                  (login.userType === 'secretary' || login.userType === 'doctor')
                "
              >
                <label
                  class="t-label-top"
                  style="margin-top: 1em"
                  *ngIf="examname == 'Inform Consent'"
                >
                  <span> Consent Type </span>
                  <select
                    class="t-select t-field"
                    [(ngModel)]="examService.consentType"
                  >
                    <option></option>
                    <option *ngFor="let type of consentTypes" [value]="type.key">{{ type.label }}</option>
                  </select>
                </label>
                <ng-container *ngIf="clinicPractitioners?.length > 1 && !login.separatedClinic">
                  <label
                    class="t-label-top"
                    style="margin-top: 1em"
                    *ngIf="examname == 'Inform Consent' && login.userType !== 'doctor'"
                  >
                    <span> Clinic's US Practitioners: </span>
                    <select
                      class="t-select t-field"
                      [(ngModel)]="examService.consentPractitioner"
                      (ngModelChange)="setConsentDocUID()"
                    >
                      <option value=""></option>
                      <ng-container *ngFor="let option of clinicPractitioners">
                        <option [value]="option.Title + ' ' + option.Name">{{ option.Title }} {{ option.Name }}</option>
                      </ng-container>
                    </select>
                  </label>
                </ng-container>
              </ng-container>
                            <!-- ========================== Consent Type And Practitioner Selector (End) ========================== -->
                            <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                                    {{pat.ID != 'default' ? 'Exit Patient': 'Exit Defaults'}}
                                </a>
                                <button class="patient-ob-btn -start_exam" [ngClass]="examname && etype ? '': 'opaque'" [disabled]="! login.isCardio && ! login.category.canCreate.exam"
                                    (click)="startExam()" *ngIf="canOpen() && etype != 'GastroForms' &&  examname!='Inform Consent' && examname!='Prescription'">
                                    {{pat.ID != 'default' ? (examname == 'Send Questionnaire' ? 'New Questionnaire' : ((etype!= 'Forms' && etype!= 'GastroForms')?'Start Exam': (etype == 'GastroForms' ?'New Form':'New Letter'))) :
                                    'Construct/Edit Defaults'}}
                                </button>
                                <button class="patient-ob-btn -start_exam" [ngClass]="examname == 'Prescription' ? '' : 'opaque'"
                                    (click)="openPrescription()" *ngIf="login.premissions?.Prescriptions && examname == 'Prescription'">
                                    New Prescription
                                </button>
                                <!-- <button class="patient-ob-btn -start_exam" [ngClass]="examname && etype ? '': 'opaque'" [disabled]="! login.category.canCreate.form"
                                (click)="startForm()" *ngIf="etype == 'GastroForms'">
                                {{pat.ID != 'default' ? 'New Form' : 'Construct/Edit Defaults'}}
                                </button> -->
                                <button
                                  class="patient-ob-btn -start_exam"
                                  [ngClass]="examname && etype && examService.consentType && examService.consentDocUID ? '' : 'opaque'"
                                  [disabled]="!login.premissions?.Consent || !examService.consentType || !examService.consentDocUID"
                                  (click)="startForm()"
                                  *ngIf="examname == 'Inform Consent' && etype === 'Forms' && examService.consentType"
                                >
                                  {{ pat.ID != 'default' ? 'New Form' : 'Construct/Edit Defaults' }}
                                </button>
                                
                            </div>

                        </div>

                    </div>

                </div>
                <!-- ========================== Create New Exam Panel (End) ========================== -->

            </div><!-- box margin -->

        </main>
        <!-- ========================== Dashboard Main Content (End) ========================== -->

        <!-- ========================== Main Sidebar (Start) ========================== -->

        <aside class="l-sidebar l-flex l-column">

            <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

            <!-- ========================== User Panel (Start) ========================== -->
            <div class="userPanel" *ngIf="pat.ID != 'default'">

                <i class="userPanel-icon icon-female">

                    <button class="btn-user_data" aria-label="user data" (click)="showPat=true"></button>

                </i>

                <div class="userPanel-userName">
                    {{pat.First+' '+pat.Last}}
                </div>

                <dl class="l-table userPanel-userInfo">
                    <div class="l-row">
                        <dt class="l-td-m">ID Number</dt>
                        <dd class="l-td-m">{{pat.ID}}</dd>
                    </div>
                    <div class="l-row">
                        <dt class="l-td-m">Age</dt>
                        <dd class="l-td-m">{{patService.getAgeMo()}}</dd>
                    </div>
                    <div class="l-row" style='margin-top: 1em' *ngIf="login.getArchiveServer()">
                        <dt class="l-td-m">History</dt>
                        <dd class="l-td-m"><a target="_blank" [href]='login.getArchiveServer()+pat.ID'><img
                                    src='../../assets/icons/oldarchive.svg' style='height: 2.2em; margin-top: 1em'></a>
                        </dd>
                    </div>
                </dl>

            </div>
            <!-- ========================== User Panel (End) ========================== -->

            <!-- ========================== Main Navigation (Start) ========================== -->
            <nav class="mainNav l-fg1 scroller">

            </nav>
            <!-- ========================== Main Navigation (End) ========================== -->

            <app-docpanel></app-docpanel>

        </aside>

        <!-- ========================== Main Sidebar (End) ========================== -->

        <app-bottombar></app-bottombar>

    </div><!-- end wrapper -->

    <!-- ========================== Delete Confirmation Popup (Start) ========================== -->
    <div class="t-popup popup-patientDetails" *ngIf="toDelete" style='display: block; max-width: 40vw;'>

        <div class="t-popup-close"></div>

        <div class="t-popup-frame">
            <div class="t-popup-body">

                <button class="t-btn-popup-close" aria-label="close popup"(click)="toDelete = null;readydelete = false;documentDelete = false"></button>

                <h2 *ngIf="documentDelete" style='color: #D7A95B'>
                    Delete document from {{toDelete.CreationTime | date : "d/M/yy, HH:mm a"}}?
                </h2>
                <h2 *ngIf="! documentDelete" style='color: #D7A95B'>
                    Delete {{toDelete.ExamType}} {{defaults? 'defaults' : 'exam from ' + (toDelete.CreationTime | date : "d/M/yy, HH:mm a")}}?
                </h2>
                <div *ngIf="! readydelete">
                    <button (click)="readydelete = true">Yes</button> <button
                        (click)="toDelete = null;readydelete = false;documentDelete = false" style='margin-left: 2em'>No</button>
                </div>
                <div *ngIf="readydelete && documentDelete">
                    <strong>WARNING document Will Be Lost!<br></strong>
                    <button (click)="deleteDocument(); toDelete = null; readydelete = false; documentDelete = false">OK</button>
                    <button (click)="toDelete = null;readydelete = false;documentDelete = false" style='margin-left: 2em'>Cancel</button>
                </div>
                <div *ngIf="readydelete && ! documentDelete">
                    WARNING exam data and media will we lost!<br>
                    <button (click)="deleteExam()">OK</button> <button (click)="toDelete = null;readydelete = false"
                        style='margin-left: 2em'>Cancel</button>
                </div>


            </div>
        </div>

    </div>
    <!-- ========================== Delete Confirmation Popup (End) ========================== -->


    <!-- ========================== Dynamic Popup Components (Start) ========================== -->
    <app-patdetails *ngIf="showPat" [pat]="pat" (closed)="showPat=false"></app-patdetails>
    <app-patforms *ngIf="typeForm" (closed)="typeForm=false;examname='';examsLoaded$.next();"></app-patforms>
    <app-informconcent *ngIf="inform" (closed)="closCalForm($event)" [form]="concentForm" [ExamType]="examname"></app-informconcent>
    <app-usg-consent-form
      *ngIf="showUsgConsent"
      (closed)="closeUsgConsent($event)"
      [form]="concentForm"
      [consentType]="examService.consentType"
    ></app-usg-consent-form>

    <app-commerror></app-commerror>
    <app-calexams *ngIf="calendarForm" (closed)="closCalForm($event)" [selectedForm]="selectedForm"></app-calexams>
    <app-loginbox *ngIf="showLogin" (closed)="showLogin=false" (viewonly)="viewonly()" [isnew]="newExam"></app-loginbox>
    <app-closepregnancy *ngIf="closePreg" [pregtoload]="closePreg" [exams]="pregExams" (examClosed)="pregClosed()" (closed)="closePreg=null"></app-closepregnancy>
    <!-- ========================== Dynamic Popup Components (End) ========================== -->

    <!-- ========================== Delete Prescription Confirmation Popup (Start) ========================== -->
    <div class="t-popup popup-patientDetails" *ngIf="prescriptionToDelete" style='display: block; max-width: 40vw;'>
        <div class="t-popup-close"></div>
        <div class="t-popup-frame" style="max-width: 30em;">
            <div class="t-popup-body">
                <button class="t-btn-popup-close" aria-label="close popup" (click)="prescriptionToDelete = null; prescriptionDeleteReady = false"></button>
                <h2 style='color: #D7A95B; text-align: center;'>Delete Prescription</h2>
                <p style='text-align: center;'>Delete prescription from {{prescriptionToDelete?.CreatedAt | date:'dd/MM/yyyy'}}?</p>
                <div *ngIf="!prescriptionDeleteReady" style="display:flex; justify-content: space-evenly;">
                    <button (click)="prescriptionDeleteReady = true" style="min-width:7em; background:#c0392b; color:#fff; border:none; padding:8px 16px; border-radius:4px; cursor:pointer;">Yes, Delete</button>
                    <button (click)="prescriptionToDelete = null; prescriptionDeleteReady = false" style="min-width:7em; padding:8px 16px; border-radius:4px; cursor:pointer;">Cancel</button>
                </div>
                <div *ngIf="prescriptionDeleteReady" style="display:flex; flex-direction:column; align-items:center; gap:10px;">
                    <p style="color:#c0392b; font-weight:bold;">WARNING: This action cannot be undone. Are you sure?</p>
                    <div style="display:flex; justify-content: space-evenly; width:100%;">
                        <button (click)="confirmDeletePrescription()" style="min-width:7em; background:#c0392b; color:#fff; border:none; padding:8px 16px; border-radius:4px; cursor:pointer;">Delete</button>
                        <button (click)="prescriptionToDelete = null; prescriptionDeleteReady = false" style="min-width:7em; padding:8px 16px; border-radius:4px; cursor:pointer;">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="t-popup popup-patientDetails" *ngIf="referralToDelete" style='display: block; max-width: 40vw;'>
        <div class="t-popup-close"></div>
        <div class="t-popup-frame" style="max-width: 30em;">
            <div class="t-popup-body">
                <button class="t-btn-popup-close" aria-label="close popup" (click)="referralToDelete = null; referralDeleteReady = false"></button>
                <h2 style='color: #D7A95B; text-align: center;'>Delete Lab Test Referral</h2>
                <p style='text-align: center;'>Delete this lab test referral?</p>
                <div style="display:flex; justify-content: space-evenly;">
                    <button (click)="confirmDeleteReferral()" style="min-width:7em; background:#D7A95B; color:#fff; border:none; padding:8px 16px; border-radius:4px; cursor:pointer;">Delete</button>
                    <button (click)="referralToDelete = null; referralDeleteReady = false" style="min-width:7em; background:#277382; color:#fff; border:none; padding:8px 16px; border-radius:4px; cursor:pointer;">Cancel</button>
                </div>
            </div>
        </div>
    </div>
    <!-- ========================== Delete Prescription Confirmation Popup (End) ========================== -->

    <!-- ========================== Missing Admission Form Popup (Start) ========================== -->
    <div class="t-popup popup-patientDetails" *ngIf="formMissing" style='display: block'>
    
        <div class="t-popup-close"></div>
    
        <div class="t-popup-frame error-w" style="max-width: 30em;">
            <div class="t-popup-body">
    
                <button class="t-btn-popup-close" aria-label="close popup" (click)="formMissing=false"></button>
    
                <h2 style='color: #D7A95B;text-align: center;'>
                    Missing Admission Form
                </h2>
                <p style='text-align: center;'>
                    Do you wish to continue without it?
                </p>
                <div style="display:flex; justify-content: space-evenly;">
                    <button (click)="formMissing=false" class="cancel" style="min-width:7.9em;">
                        Cancel
                    </button>
                    <button class="accept" style="min-width:7.9em;" (click)="startExam(true)">
                        Continue
                    </button>
                </div>
    
            </div>
        </div>

    </div>
    <!-- ========================== Missing Admission Form Popup (End) ========================== -->
</div>

<!-- ========================== Root Dynamic Popup Components (Start) ========================== -->
<app-labreport *ngIf="labReportID" [reportid]="labReportID" (closed)="labReportID=null"></app-labreport>
<app-pat-documents *ngIf="openDocumentsAdd" [showDocuments]="true" (closed)="openDocumentsAdd = false; refreshDocuments()"></app-pat-documents>
<app-send-questionnaire
  *ngIf="showSendQuestionnaire"
  [patient]="sendQuestionnairePatient"
  (closed)="onSendQuestionnaireClosed()"
></app-send-questionnaire>
<!-- ========================== Root Dynamic Popup Components (End) ========================== -->